<app-inicio-banner></app-inicio-banner>
<!-- Rastreo now integrated in banner for better UX -->
<app-inicio-beneficios></app-inicio-beneficios>
<app-inicio-servicios [limite]="4"></app-inicio-servicios>
<app-inicio-cobertura></app-inicio-cobertura>


